<template>
    <div>
    
        <CRow class="m-0 justify-content-center align-items-center">
            <div style="width:50%;padding:20px;padding-top:30px" class="text-left">
                <img style="max-width: 40px;" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            </div>
            <div style="width:50%;padding:20px;padding-top:30px" class="text-right">
                <img style="max-width: 40px;" src="../assets/img/country.png" alt="Country Image" />
            </div>
    
            <CCol sm="8" class="text-center mt-3" style="width: 90%;background-size: cover; margin: auto;">
                <!-- Additional content -->
                <div class="p-2">
                    <h5 class="custom-title-app poppin-font mt-2">Who Are You</h5>
                    <p class="custom-sub-title-app">Please enter the code we just sent to email davisdoni@email.com</p>
    
                    <CRow class="p-2">
                        <div style="width:48%;" class="card-grey p-40 mr-1">
                            <div class="p-2">
                                <img style="max-width: 100px;" src="../assets/img/worker.png" alt="Arrow Left Image" class="p-2" />
                                <h3 class="custom-header-subtitle-sub text-center">Genie Worker</h3>
                                <p class="custom-sub-app text-center">Skilled <br />Service Providers</p>
                            </div>
                        </div>
                        <div style="width:48%;" class="card-grey p-40">
                            <div class="p-2">
                                <img style="max-width: 110px;" src="../assets/img/aladdin.png" alt="Country Image" class="p-2" />
                                <h3 class="custom-header-subtitle-sub text-center">Aladdin</h3>
                                <p class="custom-sub-app text-center">Users Looking<br /> for Services</p>
                            </div>
                        </div>
                    </CRow>
                    <div class="mt-2">
                        <div @click="GoToLanguage()" class="button-border-blue text-white">
                            <label class="mt-2">Continue</label>
                        </div>
                        <br />
                    </div>
                </div>
            </CCol>
        </CRow>
        <div class="popup backdrop" v-if="isLanguagePopupVisible === true">
            <CRow class="m-0 justify-content-center align-items-end">
                <!-- Popup content -->
                <CCol sm="8" class="text-center mt-3" style="width: 90%; background-size: cover; margin: auto;">
                    <div class="bg-white-radius p-2 popup">
                        <h5 class="custom-title-app poppin-font mt-2">Select Language</h5>
                        <p class="custom-sub-title-app poppin-font">Choose your preferred language</p>
    
                        <div class="p-40">
                            <CSelect placeholder="Select Language"></CSelect>
                            <CRow class="m-2">
                                <div style="width:10%"><img style="max-width:100%" src="../assets/img/US.png" /></div>
                                <div style="width:80%">
                                    <h5 class="custom-title-app poppin-font mt-2 text-left ml-2">English (US)</h5>
                                </div>
                                <div style="width:10%"><input type="radio" class="mt-3" /></div>
                            </CRow>
                            <CRow class="m-2">
    
                                <div style="width:10%"><img style="max-width:100%" src="../assets/img/my.png" /></div>
                                <div style="width:80%">
                                    <h5 class="custom-title-app poppin-font mt-2 text-left ml-2">Malaysia</h5>
                                </div>
                                <div style="width:10%"><input type="radio" class="mt-3" /></div>
                            </CRow>
    
                            <CRow class="m-2">
                                <div style="width:10%"><img style="max-width:100%" src="../assets/img/indon.png" /></div>
                                <div style="width:80%">
                                    <h5 class="custom-title-app poppin-font mt-2 text-left ml-2">Indonesia</h5>
                                </div>
                                <div style="width:10%"><input type="radio" class="mt-3" /></div>
                            </CRow>
                        </div>
    
                        <div class="w-80 mx-auto p-40 mt-2">
                            <CButton type="button" class="button-border-blue text-white" block @click="GoToLogin">
                                Select
                            </CButton>
                            <br /> <br /> <br />
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
</template>
  


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppin&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}

/* .backdrop {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.popup {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
} */
</style>

<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
        GoToLanguage() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        GoToWho() {
            // Close the popup and backdrop
            this.isLanguagePopupVisible = false;
        },
        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/Login");
        },

    }
})
</script>
